import client from '@/http'

class Auth {
  _path = 'auth'
  _baseUrl = process.env.VUE_APP_API

  async attempt(credentials) {
    await client.get(`${this._baseUrl}/sanctum/csrf-cookie`)

    return await client.post(`${this._baseUrl}/login`, credentials)
  }

  async destroy() {
    return client.post(`${this._baseUrl}/logout`)
  }
}

export default Auth
